const STORE_NAME = import.meta.env.VITE_REACT_APP_NAME as string;

const API_URL = {
  thisisneverthat: "https://txeetupeoplchuvoe6vjz7pvja0qmmdx.lambda-url.ap-northeast-2.on.aws/",
  yeseyesee: "https://sby6hxnrquup57klez4kelijyi0urrby.lambda-url.ap-northeast-2.on.aws/",
  tune: "https://fjisuegthgbvtmu2xzz5x2sxne0gtcsl.lambda-url.ap-northeast-2.on.aws/",
  khakis: "https://fjx2mrdji4nqmarlzxxylsuqxe0svjzq.lambda-url.ap-northeast-2.on.aws/",
  jknd: "",
  sunlove: "https://jl3lgmhemoqti54ovxdna6rije0ydzlq.lambda-url.ap-northeast-2.on.aws/",
  wellbeingexpress: "https://2jwg7d4ysza7rdxa6ernzf6buy0wkitk.lambda-url.ap-northeast-2.on.aws/",
};

/**
 * 소셜로그인 계정으로 가입했는지 체크
 */
export const fetchSocialLogin = async (email: string, domain: string) => {
  const lambdaUrl = API_URL[STORE_NAME as keyof typeof API_URL];
  if (!lambdaUrl) return;

  try {
    const url = `${lambdaUrl}?email=${email}&domain=${domain}`;
    const response = await fetch(url).then((res) => res);

    // 튠 스토어일 때 람다 반환값 형태가 다르므로 따로 처리
    const isTuneStore = STORE_NAME === "tune";
    if (isTuneStore) {
      const result = await response.json();
      if (typeof result === "object" && "loginType" in result) {
        const loginType = result.loginType;
        return typeof loginType === "string" ? loginType : "";
      }
      return typeof result === "string" ? result : "";
    }

    if (response.status === 200) {
      return (await response.json()) as string;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
